// src/pages/FacturacionPresupuestos/CarteraClientesTab.js
import React, { useState } from 'react';
import { 
    FaUsers, 
    FaPlus, 
    FaSearch, 
    FaEdit, 
    FaTrash, 
    FaWhatsapp, 
    FaEnvelope, 
    FaFileInvoice, 
    FaTimes,
    FaBolt
} from 'react-icons/fa';
import './GestionTabs.css';

const CarteraClientesTab = ({
    clientes = [],
    onGuardarCliente,
    onEliminarCliente,
    onCrearDocumentoParaCliente,
    onSembrarCatalogo
}) => {
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [clienteEditando, setClienteEditando] = useState(null);

    // Formulario de edición/creación
    const [formCliente, setFormCliente] = useState({
        nombre: '',
        rfc: '',
        contacto: '',
        telefono: '',
        email: '',
        direccion: '',
        ciudad: '',
        notas: ''
    });

    const abrirModal = (cliente = null) => {
        if (cliente) {
            setClienteEditando(cliente);
            setFormCliente({
                nombre: cliente.nombre || '',
                rfc: cliente.rfc || '',
                contacto: cliente.contacto || cliente.atencionA || '',
                telefono: cliente.telefono || '',
                email: cliente.email || '',
                direccion: cliente.direccion || '',
                ciudad: cliente.ciudad || '',
                notas: cliente.notas || ''
            });
        } else {
            setClienteEditando(null);
            setFormCliente({
                nombre: '',
                rfc: '',
                contacto: '',
                telefono: '',
                email: '',
                direccion: '',
                ciudad: '',
                notas: ''
            });
        }
        setModalAbierto(true);
    };

    const handleGuardar = (e) => {
        e.preventDefault();
        if (!formCliente.nombre.trim()) {
            alert('Por favor especifica la Razón Social o Nombre del Cliente.');
            return;
        }

        const data = {
            ...formCliente,
            id: clienteEditando?.id || Date.now().toString(),
            actualizadoEn: new Date().toISOString()
        };

        onGuardarCliente(data);
        setModalAbierto(false);
    };

    const clientesFiltrados = clientes.filter(c => {
        const texto = `${c.nombre || ''} ${c.rfc || ''} ${c.contacto || ''} ${c.email || ''} ${c.telefono || ''}`.toLowerCase();
        return !busqueda || texto.includes(busqueda.toLowerCase());
    });

    return (
        <div className="gestion-tab-container">
            {/* Header */}
            <div className="gestion-tab-header">
                <div className="gestion-tab-title-group">
                    <h2>
                        <FaUsers style={{ color: '#4f46e5' }} /> Cartera de Clientes & Receptores
                    </h2>
                    <p>
                        Catálogo de clientes con aprendizaje automático al emitir presupuestos o notas de pago.
                    </p>
                </div>
                <div className="gestion-tab-actions">
                    <button 
                        type="button" 
                        className="btn-primary-zen"
                        style={{ background: '#4f46e5' }}
                        onClick={() => abrirModal()}
                    >
                        <FaPlus /> Nuevo Cliente
                    </button>
                </div>
            </div>

            {/* Filtros */}
            <div className="gestion-filter-bar">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                    <FaSearch style={{ color: '#94a3b8' }} />
                    <input 
                        type="text"
                        className="gestion-search-input"
                        placeholder="Buscar por cliente, RFC, contacto o correo..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </div>
            </div>

            {/* Tabla */}
            <div className="gestion-table-wrapper">
                <table className="gestion-zen-table">
                    <thead>
                        <tr>
                            <th>Cliente / Razón Social</th>
                            <th>RFC / ID Fiscal</th>
                            <th>Persona de Contacto</th>
                            <th>Teléfono / WhatsApp</th>
                            <th>Correo Electrónico</th>
                            <th>Dirección</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clientesFiltrados.length === 0 ? (
                            <tr>
                                <td colSpan="7" style={{ textAlign: 'center', padding: '32px', color: '#94a3b8' }}>
                                    No hay clientes registrados en la cartera. Haz clic en "Nuevo Cliente" o emite un presupuesto para agregarlos automáticamente.
                                </td>
                            </tr>
                        ) : (
                            clientesFiltrados.map((cli) => (
                                <tr key={cli.id}>
                                    <td style={{ fontWeight: 700, color: '#0f172a' }}>
                                        {cli.nombre}
                                    </td>
                                    <td>{cli.rfc || <span style={{ color: '#94a3b8' }}>N/A</span>}</td>
                                    <td>{cli.contacto || cli.atencionA || <span style={{ color: '#94a3b8' }}>-</span>}</td>
                                    <td>
                                        {cli.telefono ? (
                                            <a 
                                                href={`https://wa.me/52${cli.telefono.replace(/\D/g, '')}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                style={{ color: '#16a34a', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                                            >
                                                <FaWhatsapp /> {cli.telefono}
                                            </a>
                                        ) : (
                                            <span style={{ color: '#94a3b8' }}>-</span>
                                        )}
                                    </td>
                                    <td>
                                        {cli.email ? (
                                            <a href={`mailto:${cli.email}`} style={{ color: '#0284c7', textDecoration: 'none' }}>
                                                {cli.email}
                                            </a>
                                        ) : (
                                            <span style={{ color: '#94a3b8' }}>-</span>
                                        )}
                                    </td>
                                    <td style={{ maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {cli.direccion || '-'}
                                    </td>
                                    <td>
                                        <div className="row-actions-group">
                                            <button 
                                                type="button"
                                                className="btn-row-action"
                                                style={{ color: '#2b5329', borderColor: '#86efac' }}
                                                onClick={() => onCrearDocumentoParaCliente(cli)}
                                                title="Iniciar Presupuesto con este cliente"
                                            >
                                                <FaFileInvoice /> Emitir
                                            </button>
                                            <button 
                                                type="button" 
                                                className="btn-row-action"
                                                onClick={() => abrirModal(cli)}
                                                title="Editar Cliente"
                                            >
                                                <FaEdit />
                                            </button>
                                            <button 
                                                type="button" 
                                                className="btn-row-action delete"
                                                onClick={() => onEliminarCliente(cli.id)}
                                                title="Eliminar de la cartera"
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal para Agregar/Editar Cliente */}
            {modalAbierto && (
                <div className="modal-sendgrid-overlay" onClick={() => setModalAbierto(false)}>
                    <div className="modal-sendgrid-container" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-sendgrid-header modal-header-clientes">
                            <h3 className="modal-sendgrid-title modal-title-clientes">
                                <FaUsers style={{ color: '#4f46e5' }} /> {clienteEditando ? 'Editar Cliente' : 'Nuevo Cliente'}
                            </h3>
                            <button type="button" className="modal-sendgrid-close" onClick={() => setModalAbierto(false)}>
                                <FaTimes />
                            </button>
                        </div>
                        <form onSubmit={handleGuardar}>
                            <div className="modal-sendgrid-body">
                                <div className="mini-form-grid">
                                    <div className="mini-form-full sendgrid-input-group">
                                        <label>Nombre o Razón Social *</label>
                                        <input 
                                            type="text" 
                                            required
                                            className="sendgrid-input-control"
                                            value={formCliente.nombre}
                                            onChange={(e) => setFormCliente({ ...formCliente, nombre: e.target.value })}
                                            placeholder="Ej. Fraccionamiento Paseos de la Venta A.C."
                                        />
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>RFC / Identificador</label>
                                        <input 
                                            type="text" 
                                            className="sendgrid-input-control"
                                            value={formCliente.rfc}
                                            onChange={(e) => setFormCliente({ ...formCliente, rfc: e.target.value })}
                                            placeholder="XAXX010101000"
                                        />
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>Atención a / Contacto</label>
                                        <input 
                                            type="text" 
                                            className="sendgrid-input-control"
                                            value={formCliente.contacto}
                                            onChange={(e) => setFormCliente({ ...formCliente, contacto: e.target.value })}
                                            placeholder="Ej. Lic. Roberto Silva"
                                        />
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>Teléfono / WhatsApp</label>
                                        <input 
                                            type="tel" 
                                            className="sendgrid-input-control"
                                            value={formCliente.telefono}
                                            onChange={(e) => setFormCliente({ ...formCliente, telefono: e.target.value })}
                                            placeholder="442 123 4567"
                                        />
                                    </div>
                                    <div className="sendgrid-input-group">
                                        <label>Correo Electrónico</label>
                                        <input 
                                            type="email" 
                                            className="sendgrid-input-control"
                                            value={formCliente.email}
                                            onChange={(e) => setFormCliente({ ...formCliente, email: e.target.value })}
                                            placeholder="contacto@cliente.mx"
                                        />
                                    </div>
                                    <div className="mini-form-full sendgrid-input-group">
                                        <label>Dirección Completa</label>
                                        <input 
                                            type="text" 
                                            className="sendgrid-input-control"
                                            value={formCliente.direccion}
                                            onChange={(e) => setFormCliente({ ...formCliente, direccion: e.target.value })}
                                            placeholder="Calle, Número, Colonia, Municipio, C.P."
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-sendgrid-footer">
                                <button type="button" className="btn-modal-cancel" onClick={() => setModalAbierto(false)}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn-modal-send btn-save-clientes">
                                    Guardar Cliente
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CarteraClientesTab;
